import React from 'react';
import {useNavigate} from "react-router-dom";

function PayError(props) {

    const navigate = useNavigate();


    return (
        <div>
            <main className="flex-grow py-16 font-script">
                <div className="max-w-7xl mx-auto px-6">

                    <div className="max-w-4xl mx-auto">





                        <section id="general-error-fallback"
                                 className="bg-white rounded-[24px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-10 border border-gray-100 flex flex-col justify-center">
                            <div className="text-center">
                                <div className="mb-8 relative inline-block">
                                    <div
                                        className="w-32 h-32 bg-gray-50 rounded-2xl flex items-center justify-center mx-auto border border-gray-100 transform -rotate-3">
                                        <i className="fas fa-plug text-gray-400 text-6xl"></i>
                                    </div>
                                    <div
                                        className="absolute -bottom-2 -right-2 w-10 h-10 bg-error-light rounded-full flex items-center justify-center border-2 border-white shadow-sm">
                                        <i className="fas fa-times text-error-red"></i>
                                    </div>
                                </div>

                                <h2 className="text-3xl font-print font-bold text-gray-800 mb-4">Oops! Something went
                                    wrong</h2>
                                <p className="text-gray-600 mb-8 max-w-md mx-auto">We're experiencing a temporary
                                    technical hiccup. Don't worry, your cart is saved and no charges have been made.</p>

                                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                   {/* <button
                                        className="bg-custom-green hover:bg-dark-green text-white font-medium py-3.5 px-8 rounded-full transition-colors flex items-center justify-center gap-2">
                                        <i className="fas fa-sync-alt"></i> Refresh Page
                                    </button>*/}
                                    <button
                                        onClick={() => navigate('/order', { replace: true })}
                                        className="bg-white border border-custom-green text-custom-green hover:bg-cream font-medium py-3.5 px-8 rounded-full transition-colors">
                                        Return to Home
                                    </button>
                                </div>
                            </div>
                        </section>

                    </div>


                    <section id="help-center-shortcuts" className="mt-16">
                        <h3 className="text-2xl font-print text-gray-800 mb-8 text-center">Still having
                            trouble?</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                            <div
                                className="bg-white rounded-[16px] p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow flex items-start gap-4 cursor-pointer group">
                                <div
                                    className="w-12 h-12 bg-cream rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-custom-green transition-colors">
                                    <i className="fas fa-envelope text-custom-green group-hover:text-white text-xl"></i>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-800 mb-1">Email Support</h4>
                                    <p className="text-sm text-gray-500 mb-2">We reply within 24 hours</p>
                                    <span
                                        className="text-custom-green text-sm font-medium flex items-center gap-1 group-hover:text-dark-green">
                            support@rotheras.gr <i className="fas fa-arrow-right text-xs"></i>
                        </span>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </main>

        </div>
    );
};

export default PayError;